import React, { Component } from 'react';
import { api } from '../services/rest';
import { session } from '../authentication';
import MenuItem from '../components/Menu/MenuItem';
import { NavLink } from 'react-router-dom';

class ProjectSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            adminIds: []
        }
        this.onlyOne = this.onlyOne.bind(this);
    }
    componentDidMount() {
        api.get("/Projects/Index")
            .then(res => this.setState({ projects: res.data }));
        api.get("/Projects/AdminIds")
            .then(res => this.setState({ adminIds: res.data }));
    }

    onlyOne(projects) {
        return projects.length === 1 &&
            projects[0].subMenuItems.length === 1
    }

    render() {
             
        var items = this.state.projects.map(item => <MenuItem item={item} key={item.text} url={item.subMenuItems[0].url} />);
        var currentUser = session.getUser();
        var newProject = (this.state.adminIds.find(x => x === currentUser.id)) ?
            <li key={this.props.text}>
                <NavLink activeClassName="active" to={`/NewProject`}>New Project</NavLink>            
            </li> : "";//
        
        if (this.state.projects.length === 0) {
            return <div></div>
        }
        else {
            return (
                <div>
                    <div className="sidebar sidebar-inverse pr-0 pl-0">
                        <ul className="nav sidebar-nav ">{items}{newProject}</ul>
                    </div>
                    <div className="sidebar-offset container-fluid">
                        <div className="jumbotron">
                            <h1>Welcome to Blaze</h1>
                            <p>Blaze is a lightweight CMS designed to help you make blazingly fast edits to your key data.
                                It pares away the fluff of a typical CMS and is tailored to focus on your most critical tasks.
                                If you need more extensive changes, please contact Truebyte.
                            </p>
                        </div>
                        <p>To get started, select the site you want to work on from the menu.</p>
                    </div>
                </div>
             )
        }
    }
}

export default ProjectSelection;